import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

interface CreateUserPayload {
  email: string;
  first_name: string;
  last_name: string;
  roles: string[];
}

export const useCreateCustomerBoUser = (customerId: number) => {
  const queryClient = useQueryClient();

  const createCustomerUser = async (
    payload: CreateUserPayload
  ): Promise<void> => {
    await Axios.post(
      `${POST_URL(customerId.toString()).createUserBo}`,
      payload
    );
  };

  return useMutation<void, AxiosError<BaseError>, CreateUserPayload>(
    createCustomerUser,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['customerBoIam', customerId]);
      },
      useErrorBoundary: false
    }
  );
};
